export const createTeleInterconsultLog = async (resource, data) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}tele_interconsult_log`, data).then(
    (response) => {
      // success callback
      result = response.body.tele_interconsult_log;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};

export const getTicLogByTicId = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}tele_interconsult_log/find_by_tele_interconsult_id/${id}`).then(
    (response) => {
      // success callback
      result = response.body.tele_interconsult_log;
    },
    (response) => {
      console.log(response);
      // error callback
    }
  );
  return result;
};
